var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 bg-white shadow-lg bottom-0"},[_vm._t("default"),_c('div',{staticClass:"float-right"},[_vm._t("right")],2),_c('div',{staticClass:"d-block"},[_vm._t("left")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }